module.exports = __webpack_public_path__ + "static/img/code4.2111859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code4.png
// module id = yLdZ
// module chunks = 128